// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjqD","placeholdersHeader":"styles_placeholdersHeader__2IYhu","editorStyle":"styles_editorStyle__2qSBp","placeholdersBox":"styles_placeholdersBox__1Nu_w"};